import { SessionSiteSelectors } from '~selectors/SessionInfoSelectors';
import { areLinkedTasksEnabled } from '~src/linkedTasks/utils/LinkedTaskHelpers';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { hasRunNowPermission } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { runFlowTaskRunNow } from '../actions/RunFlowTaskMenuActions';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import { RunRunFlowTaskActions, userHasRunRunFlowTaskPermissions } from '../utils/FlowTaskActionUtils';

export const RunFlowTaskRunNowAction: IEntityAction<RunFlowTaskInfo, RunRunFlowTaskActions> = {
  name: EntityActionNames.TasksRunNow,
  translateName: Messages.runNow_action,
  isVisible: (targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length > 0;
  },
  isClickable: (availableActions: RunRunFlowTaskActions, targetItems: RunFlowTaskInfo[], state: AppState) => {
    const runNowPermission = hasRunNowPermission(state);

    if (areLinkedTasksEnabled()) {
      const hasLinkedTask = targetItems.find((item) => item.taskType === 'LinkedTask') !== undefined;
      const linkedTaskRunNowPermission = SessionSiteSelectors.isLinkedTaskRunNowEnabledOnSiteEnabled(state);
      if (hasLinkedTask) {
        return targetItems.length > 0 && runNowPermission && linkedTaskRunNowPermission && userHasRunRunFlowTaskPermissions(availableActions);
      }
    }
    return targetItems.length > 0 && runNowPermission && userHasRunRunFlowTaskPermissions(availableActions);
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => runFlowTaskRunNow(targetItems)
};
